// TEMPORARY: diagnosis of the iOS swipe freeze, to remove once fixed.
// ?debug=1 shows a timeline on screen. ?exp=solo: no preloaded next video. ?exp=mp4: no HLS.
const params = new URLSearchParams(window.location.search);

export const DEBUG = params.has('debug');
export const EXP = params.get('exp') || '';

const lines: string[] = [];
let box: HTMLDivElement | null = null;
const t0 = performance.now();

export const log = (text: string) => {
  if (!DEBUG) {
    return;
  }
  lines.push(`${Math.round(performance.now() - t0)} ${text}`);
  if (lines.length > 40) {
    lines.shift();
  }
  if (box) {
    box.textContent = lines.join('\n');
  }
};

export const installDebug = (root: HTMLElement) => {
  if (!DEBUG || box) {
    return;
  }
  box = document.createElement('div');
  box.style.cssText = 'position:fixed;top:0;left:0;right:0;z-index:99999;pointer-events:none;'
    + 'font:9px/1.15 monospace;color:#0f0;background:rgba(0,0,0,0.55);white-space:pre;padding:2px';
  document.body.appendChild(box);
  log(`exp=${EXP || 'none'}`);

  // A long gap means the page's thread was blocked; no gap during a frozen screen means the
  // freeze is in the browser itself.
  let last = performance.now();
  const frame = () => {
    const now = performance.now();
    if (now - last > 60) {
      log(`GAP ${Math.round(now - last)}ms`);
    }
    last = now;
    requestAnimationFrame(frame);
  };
  requestAnimationFrame(frame);

  let moves = 0;
  const onTouch = (event: TouchEvent) => {
    // Delay between the finger and the page receiving it.
    const late = Math.round(performance.now() - event.timeStamp);
    if (event.type === 'touchmove') {
      moves += 1;
      if (moves > 3 && late < 50) {
        return;
      }
    } else {
      moves = 0;
    }
    log(`${event.type} late=${late}ms`);
  };
  ['touchstart', 'touchmove', 'touchend'].forEach((type) => {
    window.addEventListener(type, onTouch as EventListener, { capture: true, passive: true });
  });

  const slideOf = (el: Element) => {
    const container = root.querySelector('.react-swipeable-view-container');
    return container ? Array.prototype.findIndex.call(container.children, (s: Element) => s.contains(el)) : -1;
  };
  ['loadstart', 'loadeddata', 'playing', 'waiting', 'pause', 'play', 'stalled'].forEach((type) => {
    root.addEventListener(type, (event) => {
      const v = event.target as HTMLVideoElement;
      log(`v${slideOf(v)} ${type} t=${v.currentTime.toFixed(2)} rs=${v.readyState}`);
    }, true);
  });
  root.addEventListener('transitionend', () => log('transitionend'));
};
